document.addEventListener('DOMContentLoaded', function () {
  var sz = 0;
  var timersz = setInterval(function () {
    var bestFitSizeChart = document.querySelector('.best-fit-size-chart');
    var labelWrapper = document.querySelector('.product__label-wrapper');

    if (bestFitSizeChart) {
      if (labelWrapper && labelWrapper.innerHTML.toLowerCase().includes('size')) {
        labelWrapper.appendChild(bestFitSizeChart);
      }
      clearInterval(timersz);
    }

    if (bestFitSizeChart) {
      if (labelWrapper && labelWrapper.innerHTML.includes(' Size ')) {
        labelWrapper.appendChild(bestFitSizeChart);
      }
      clearInterval(timersz);
    }

    if (sz > 200) {
      clearInterval(timersz);
    }

    sz++;
  }, 50);

document.querySelectorAll('.new-read-more').forEach(function(element) {
  element.addEventListener('click', function() {
    document.querySelectorAll('.section-header__subheading').forEach(function(subheading) {
      subheading.classList.add('collapse');
    });
    this.style.display = 'none';
  });
});

});


var ur = window.location.href;
if(ur.includes('')){

  
 (function(document, tag) {
    var scriptTag = document.createElement(tag), // create a script tag
        firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
    scriptTag.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js'; // set the source of the script to your script
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
}(document, 'script'));



  
document.addEventListener('DOMContentLoaded', function () {
 
 
   setTimeout(function(){ 


$('div#shown_form input.form-control').change(function(){
  var prop = $(this).attr('name');
   $('#within_form [name="'+ prop +'"]').val($(this).val()); 
}); 
$('div#shown_form  .checkbox input').click(function(){
  $('#within_form  .checkbox input').click()
}); 
   jQuery('.media img').click(function(){
  $('.lighbox__open-button.visible').eq(0).click();
}); 
 jQuery('.read-more').click(function(){
  jQuery('.product__description-content').eq(0).addClass('full-content')
    $(this).hide();
}); 
 jQuery(document).scroll(function() {
    if(jQuery('.quick-purchase-bar.active').length){
      jQuery('body').addClass('show-sticky');
    }
   else{
     jQuery('body').removeClass('show-sticky');
   }
    
}); 



  jQuery('#simple-shipping').click(function(e){
  e.stopPropagation();
  jQuery('.simple-shipping-popup').eq(0).addClass('open')
    jQuery('body').addClass('popupp');
  });   

         jQuery('#simple-free-return').click(function(e){
  e.stopPropagation();
  jQuery('.simple-free-return-popup').eq(0).addClass('open')
          jQuery('body').addClass('popupp');
  });   
  
        jQuery('#simple-return').click(function(e){
  e.stopPropagation();
  jQuery('.simple-return-popup').eq(0).addClass('open')
          jQuery('body').addClass('popupp');
  });   

jQuery('.how-to-measure-popup').click(function(e){
  e.stopPropagation();
  jQuery('.simple-made-popup').eq(0).addClass('open')
          jQuery('body').addClass('popupp');
  });        



        jQuery('#simple-warranty').click(function(e){
  e.stopPropagation();
  jQuery('.simple-warranty-popup').eq(0).addClass('open')
          jQuery('body').addClass('popupp');
  });   

     
        jQuery('#simple-promise').click(function(e){
  e.stopPropagation();
  jQuery('.simple-promise-popup').eq(0).addClass('open')
          jQuery('body').addClass('popupp');
  });   
 jQuery('span.simple-close').click(function(){
  jQuery(this).parent().parent().parent().removeClass('open')
   jQuery('body').removeClass('popupp');
}); 
    
    jQuery('.simple-popup').click(function(event){
  event.stopPropagation();
});
   jQuery(window).click(function() {
     if(jQuery('body > .open').length){
       jQuery('span.simple-close').click();
     }
  
});

 }, 1000); 
})
}


var ur = window.location.href;
if(ur.includes('/collection')){
   (function(document, tag) {
    var scriptTag = document.createElement(tag), // create a script tag
        firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
    scriptTag.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js'; // set the source of the script to your script
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
}(document, 'script'));
document.addEventListener('DOMContentLoaded', function () {
if(document.querySelectorAll('.section-header__subheading').length == 0 && document.querySelectorAll('.new-read-more').length){
  document.querySelectorAll('.new-read-more')[0].remove();
}
});
}